/** Тексты пространства «pet». Ключи именуются по смыслу, а не по месту. */
export const pet = {
  error: {
    load: 'Не получилось загрузить питомцев',
  },

  /* Заголовки «заявок нет» и «архив пуст» общие — они в common.empty. */
  empty: {
    published: {
      title: 'Питомцев пока нет',
      text: 'Каждый питомец проходит проверку квест-мастера: в карточке персонажа он появится после неё.',
    },
    requests: {
      text: 'Здесь висят отправленные питомцы, пока их не рассмотрели, и те, кого завернули.',
    },
    archived: {
      text: 'Сюда попадают питомцы, которых убрали из карточки.',
    },
  },

  search: {
    placeholder: 'Кличка питомца',
  },

  action: {
    create: 'Завести',
    submit: 'Отправить на проверку',
  },

  /* Врезка над формой: объясняет, что будет с правкой. */
  note: {
    create:
      'Питомец сразу уйдёт на проверку. В карточке персонажа он появится, когда квест-мастер согласится.',
    rejected: 'Заявку завернули — в форме её текст. Поправьте и отправьте заново.',
    unpublished: 'Питомец ещё не публиковался — правка остаётся в той же заявке.',
    published: 'Правка не трогает то, что уже в карточке: она уедет отдельной версией на проверку.',
  },

  toast: {
    created: 'Питомец ушёл на проверку',
    archived: 'Питомец убран в архив',
  },

  card: {
    /** Винительный падеж: «Отправить питомца в архив?». */
    subject: 'питомца',
    passport: 'паспорт',
    archived: 'Вернуть из архива пока нельзя — попросите квест-мастера.',
  },

  form: {
    section: {
      about: 'Кто это',
      photos: 'Снимки',
    },
    species: {
      hint: 'Кот, сова, что-то совсем своё',
    },
    photo: {
      label: 'Фотография питомца',
      hint: 'То, что увидят в карточке персонажа.',
    },
    passport: {
      label: 'Паспорт питомца',
      hint: 'Если у питомца есть оформленный паспорт.',
    },
    blocker: 'Без клички питомца не сохранить — остальное необязательно.',
  },
} as const;
